import { render, staticRenderFns } from "./ModalAddProductLanguage.vue?vue&type=template&id=92d67760&"
import script from "./ModalAddProductLanguage.vue?vue&type=script&lang=js&"
export * from "./ModalAddProductLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports